import {
  useNormalizer,
  useDate,
} from '@sttedra_ui/framework';

const {
  getString,
  getDate,
  getNumber,
  getObjectFilled,
} = useNormalizer();

const {toISOStringWithTimezone} = useDate();

class RegisterUserApiRequestModel {
  // #region Props
  birthDate;
  email;
  identificationNumber;
  identificationValidityDate;
  name;
  phone;
  secondSurname;
  supportNumber;
  codIneMunicipio;
  surname;
  // #endregion

  constructor(registerData) {
    // (!) Always at the beginning
    this.identificationNumber = this.getStringToUpperCase(registerData?.identificationNumber);

    this.birthDate = this.getDateTimeStamp(registerData?.birthDate);
    this.email = getString(registerData?.email);
    this.phone = this.getPhone(registerData?.phone);

    this.name = this.getStringToUpperCase(registerData?.name);
    this.secondSurname = this.getStringToUpperCase(registerData?.secondSurname);
    this.surname = this.getStringToUpperCase(registerData?.surname);

    this.codIneMunicipio = this.getCodeIneMunicipio(registerData?.codIneMunicipio);

    // (!) Always at the end
    this.supportNumber = this.getSupportNumber(registerData?.supportNumber);
    this.identificationValidityDate =
      this.getIdentificationValidityDate(registerData?.validDateDNI);

    this.legalGuardian = this.getLegalGuardian(registerData?.legalGuardian);
  }

  getLegalGuardian(legalGuardian = {}) {
    if (!getObjectFilled(legalGuardian)) return null;

    const {
      birthDate,
      identificationNumber,
      validDateDNI,
      legalRelationshipType,
      name,
      secondSurname,
      supportNumber,
      surname,
    } = legalGuardian;

    return {
      birthDate: this.getDateTimeStamp(birthDate),
      identificationNumber: this.getStringToUpperCase(identificationNumber),
      legalRelationshipType: this.getNumberValue(legalRelationshipType?.value),
      name: this.getStringToUpperCase(name),
      secondSurname: this.getStringToUpperCase(secondSurname),
      surname: this.getStringToUpperCase(surname),
      identificationValidityDate: this.getIdentificationValidityDate(validDateDNI, identificationNumber),
      supportNumber: this.getSupportNumber(supportNumber, identificationNumber),
    };
  }

  getCodeIneMunicipio(codIneMunicipio = {}) {
    if (!getObjectFilled(codIneMunicipio)) return null;
    return String(codIneMunicipio.codIneMunicipio);
  }

  isNie(identificationNumber = this.identificationNumber) {
    return identificationNumber?.charAt(0).toUpperCase() === 'X' ||
      identificationNumber?.charAt(0).toUpperCase() === 'Y' ||
      identificationNumber?.charAt(0).toUpperCase() === 'Z';
  }

  isDni() {
    return !this.isNie() && this.identificationNumber;
  }

  getSupportNumber(value, identificationNumber = this.identificationNumber) {
    if (!getString(value)) return null;
    if (this.isNie(identificationNumber)) {
      const letter = value.charAt(0).toUpperCase();
      const numValue = value.substr(1).padStart(8, '0');
      return String(letter + numValue);
    } else {
      const letters = value.substr(0, 3).toUpperCase();
      const numValue = value.substr(3);
      return String(letters + numValue);
    }
  }

  getIdentificationValidityDate(value, identificationNumber = this.identificationNumber) {
    if (!this.getDateTimeStamp(value)) return null;
    return value && !this.isNie(identificationNumber) ? this.getDateTimeStamp(value) : null;
  }

  getNumberValue(value) {
    if (!getNumber(value)) return null;
    return String(value);
  }

  getStringToUpperCase(value) {
    if (!getString(value)) return null;
    return value.toUpperCase().trim();
  }

  getPhone(value) {
    if (!getString(value)) return null;
    return value.replace(/ /g, '');
  }

  getDateTimeStamp(value) {
    if (getString(value)) {
      // // Convert the input string into a list of components
      // const dateComponents = value.split('/');
      // // Create a new date with the components
      // const date = new Date(dateComponents[2], dateComponents[1] - 1, dateComponents[0]);

      // // Convert the date to ISO format and remove the time part
      // const stringTimeZone = toISOStringWithTimezone(date);
      // if (!stringTimeZone) return null;
      // return stringTimeZone.replace(/[-+]\d{2}:\d{2}$/, '');
      return value;
    }

    if (getDate(value)) {
      const stringTimeZone = toISOStringWithTimezone(value);
      const date = new Date(stringTimeZone);
      date.setHours(0, 0, 0, 0);

      const stringTimeZone2 = toISOStringWithTimezone(date);
      if (!stringTimeZone2) return null;
      return stringTimeZone2.replace(/[-+]\d{2}:\d{2}$/, '');
    }
  }
}

export default RegisterUserApiRequestModel;
